export default [
  {
    path: "/",
    name: "default",
    meta: {
      requiresAuth: true,
    },
    component: () => import("./views/_dashboard/list"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/_auth/login"),
    meta: {
      requiresVisitor: true,
    },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    meta: { requiresAuth: true },
    component: () => import("./views/_dashboard/list"),
  },
  {
    path: "/wingband",
    name: "wingband",
    meta: { requiresAuth: true },
    component: () => import("./views/_wingband/create"),
  },
  {
    path: "/search",
    name: "search",
    meta: { requiresAuth: true },
    component: () => import("./views/_search/search"),
  },
  {
    path: "/user",
    name: "user",
    meta: { requiresAuth: true },
    component: () => import("./views/_user/list"),
  },
  {
    path: "/user/create",
    name: "user-create",
    meta: { requiresAuth: true },
    component: () => import("./views/_user/create"),
  },
  {
    path: "/user/view",
    name: "user-view",
    meta: { requiresAuth: true },
    component: () => import("./views/_user/view"),
  },
  {
    path: "/user/statistics",
    name: "user-statistics",
    meta: { requiresAuth: true },
    component: () => import("./views/_user/statistics"),
  },
  {
    path: "/seasons",
    name: "seasons",
    meta: { requiresAuth: true },
    component: () => import("./views/_seasons/list"),
  },
  {
    path: "/summary",
    name: "summary",
    meta: { requiresAuth: true },
    component: () => import("./views/_summary/list"),
  },

  {
    path: "/archive",
    name: "archive",
    meta: { requiresAuth: true },
    component: () => import("./views/_archive/list"),
  },
  {
    path: "/security",
    name: "security",
    meta: { requiresAuth: true },
    component: () => import("./views/_security/list"),
  },
  {
    path: "/activity-logs",
    name: "activity-logs",
    meta: { requiresAuth: true },
    component: () => import("./views/_activity-logs/list"),
  },
  {
    path: "/mobile-dashboard",
    name: "mobile-dashboard",
    meta: { requiresAuth: true },
    component: () => import("./views/_mobile-dashboard/list"),
  },
  {
    path: "/mobile-wingband",
    name: "mobile-wingband",
    meta: { requiresAuth: true },
    component: () => import("./views/_mobile-wingband/create"),
  },
  {
    path: "/icons/boxicons",
    name: "Boxicons Icon",
    meta: { requiresAuth: true },
    component: () => import("./views/icons/boxicons"),
  },
  {
    path: "/icons/materialdesign",
    name: "Materialdesign Icon",
    meta: { requiresAuth: true },
    component: () => import("./views/icons/materialdesign"),
  },
  {
    path: "/icons/dripicons",
    name: "Dripicons Icon",
    meta: { requiresAuth: true },
    component: () => import("./views/icons/dripicons"),
  },
  {
    path: "/admin-settings/season-colors",
    name: "season-colors",
    meta: { requiresAuth: true },
    component: () => import("./views/_admin-settings/season-colors"),
  },
];